'use strict';

import angular from 'angular';
import grid from 'angular-ui-grid';

export class CategoryProductComponent {

  deleteRow: Function;

  data;
  category;
  
  options;
  characteristics;
  characteristic;
  selected;
  grid;

  /*@ngInject*/
  constructor($scope, Storage, $q) {
    this.Storage = Storage;
    this.scope   = $scope;
    this.Promise = $q.defer;

    this.scope.deleteRow = this.deleteRow.bind(this);
  }

  $onInit() {
    //this.module   = this.data.module;
    this.category        = this.data.category;
    this.characteristics = this.Storage.getCharacteristics();

    this.Storage.loadCategoryCharacteristics(this.category._id)
      .then(characteristics => {
        characteristics.sort((c1, c2) => {
          var o1 = c1.order || 0;
          var o2 = c2.order || 0;

          return o1 > o2 ? 1 : -1;
        });

        this.selected = characteristics;

        this.options = {
          primaryKey: '_id',
          enableCellEdit: true,
          enableRowSelection: true,
          enableRowHeaderSelection: false,
          multiSelect: false,
          modifierKeysToMultiSelect: false,
          noUnselect: true,
          rowEditWaitInterval: -1,
          data: this.selected,
          onRegisterApi: (gridApi) => {
            this.grid = gridApi;

            /*
            this.grid.selection.on.rowSelectionChanged(this.scope, (row) => {
              this.selected = undefined;

              if(row.isSelected){
                this.selected = row.entity;
              }
            });
            */
            
            this.grid.edit.on.afterCellEdit(this.scope, (rowEntity, colDef, newValue, oldValue) => {
              
              if(oldValue  == newValue) {
                return false;
              }

              return this.Storage.saveCategoryCharacteristic(rowEntity)
                .then(() => {
                  this.grid.rowEdit.setRowsClean([rowEntity]);
                });
            });
          },
          columnDefs: [{
            displayName: '#',
            field: '_id',
            groupable: false,
            resizable: false,
            sortable: false,
            visible: false,
            width: 50
          }, {
            displayName: 'Характеристика',
            field: 'carachteristicId',
            groupable: false,
            resizable: true,
            sortable: false,
            visible: true,
            width: 200,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.getCellValue(row, col) | renderCharacteristic"></div>',
            cellEditableCondition: () => false,
          }, {
            displayName: 'Занчение по-умолчанию',
            field: 'defaultValue',
            sortable: false,
            width: 100
          }, {
            displayName: 'Использовать при выводе',
            field: 'useInProductName',
            type: 'boolean', 
            cellTemplate: '<span style="padding:5px;">{{row.entity.useInProductName ? "Да" : ""}}</span>',
          }, {
            displayName: 'Сортировка',
            field: 'order',
            type: 'number', 
            sortable: false,
            width: 100
          }, {
            displayName: '#',
            name: ' ',
            cellTemplate: '<span style="padding:5px;"><a href="javascript:;" ng-click="grid.appScope.deleteRow(row.entity)"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></a></span>',
          }]
        };
      })
  }

  deleteRow(row) {
    return this.Storage.removeCategoryCharacteristic(row)
      .then(() => {
        var i = this.selected.forEach((item, index) => {
          if(row._id == item._id){
            this.selected.splice(index, 1);
          }
        });
      });
  }

  onSelect() {
    if( ! this.characteristic){
      return;
    }

    var sel = this.selected.filter(row => row.carachteristicId == this.characteristic._id).shift();

    if(sel){
      this.grid.selection.selectRow(sel);
      this.grid.edit.raise.beginCellEdit(sel, 'defaultValue');
      this.characteristic = undefined;
      return;
    }

    return this.Storage.saveCategoryCharacteristic({
      categoryId: this.category._id,
      carachteristicId: this.characteristic._id,
      defaultValue: '',
      useInProductName: false,
      order: 0
    })
    .then(row => {
      this.selected.push(row);

      this.characteristic = undefined;
    });
  }
}

export default angular.module('storageApp.category-product', [
    grid,
    grid + '.selection',
    grid + '.edit',
    grid + '.rowEdit',
    grid + '.saveState',
    grid + '.grouping',
  ])
  .component('categoryProduct', {
    bindings: {data: '='},
    transclude: true,
    template: require('./category-product.html'),
    controller: CategoryProductComponent,
    controllerAs: 'categoryProductCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/category-product/category-product.component.js